export const it = {
  passwordStrengthMeter: {
    strengthLevel: {
      default: "Sicurezza password",
      notValid: "Non valida",
      safe: "Sicura",
      strong: "Forte",
    },
    strengthTip: {
      lessThen10Chars: "Meno di 10 caratteri",
      minimumRequirements: "Criteri minimi non rispettati",
      reach13Chars:
        "Raggiungi i 13 caratteri per avere una password più sicura",
    },
    rules: {
      length: "La password deve essere tra i 10 ed i 24 caratteri",
      lowercase: "Deve contenere almeno una lettera minuscola",
      uppercase: "Deve contenere almeno una lettera maiuscola",
      number: "Deve contenere almeno un numero",
      specialCharacter: `Deve contenere almeno uno dei seguenti caratteri speciali:
        , . ; : ' + - < > = | ? ! " $ % ( ) ^ _ * # @ [ ] /  '{ '}
      `,
    },
  },
  formActions: {
    cancel: "Annulla",
    retry: "Riprova",
    close: "Chiudi",
    search: "Cerca",
  },
  formFields: {
    firstName: "Nome",
    firstNamePlaceholder: "Inserisci il nome",
    lastName: "Cognome",
    lastNamePlaceholder: "Inserisci il cognome",
    male: "Maschio",
    female: "Femmina",
    birthDate: "Data di nascita",
    birthDatePlaceholder: "GG/MM/AAAA",
    nationOfBirth: "Stato di nascita",
    citizenship: "Paese di cittadinanza",
    nationOfBirthPlaceholder: "Seleziona stato",
    placeOfBirth: "Città di nascita",
    placeOfBirthPlaceholder: "Seleziona città",
    provinceOfBirth: "Provincia di nascita",
    provinceOfBirthPlaceholder: "Seleziona provincia",
    fiscalCode: "Codice Fiscale",
  },
  formInfo: {
    noResult: "Nessun risultato",
  },
  formFieldValidation: {
    required: "Campo obbligatorio",
    format: "Formato non valido",
    stringLength: "Sono richiesti {len} caratteri",
    dateFormat: "Formato data non valido",
    maxDate: "Superiore alla data massima consentita.",
    minDate: "Inferiore alla data minima consentita.",
  },
  formErrors: {
    requestError:
      "Si è verificato un errore durante l'elaborazione della richiesta.",
    verifyData: "Verifica che i dati inseriti siano corretti",
  },
  formSuccess: {
    confirmTaxCodeGenerated: "Codice fiscale generato con successo",
  },
  otpField: {
    notReceivedQuestion: "Non hai ricevuto l'SMS?",
    otpSendAgain: "Invia di nuovo",
    otpSentSuccessTitle: "Codice di verifica inviato",
    otpSentErrorTitle: "Codice di verifica non inviato",
    otpSentSuccess: "Il codice è stato inviato al tuo numero di cellulare.",
    otpSentError:
      "Si è verificato un errore imprevisto nell'invio del codice, riprova.",
    otpWaitTitle: "Attendi prima dell'invio di un nuovo codice",
    otpWaitMessage: "Potrai inviare di nuovo il codice tra {countdown} secondi",
    typeInChat: "scrivi in chat",
    otpRequestEmailChange:
      "Se ti sei accorto di aver inserito un numero sbagliato, {link} per richiederne la modifica.",
  },
  otpFieldForMail: {
    notReceivedQuestion: "Non hai ricevuto la mail?",
    otpSendAgain: "Invia di nuovo",
    otpSentSuccessTitle: "Codice di verifica inviato",
    otpSentErrorTitle: "Codice di verifica non inviato",
    otpSentSuccess: "Il codice è stato inviato al tuo indirizzo email.",
    otpSentError:
      "Si è verificato un errore imprevisto nell'invio del codice, riprova.",
    otpWaitTitle: "Attendi prima dell'invio di un nuovo codice",
    otpWaitMessage: "Potrai inviare di nuovo il codice tra {countdown} secondi",
    typeInChat: "scrivi in chat",
    otpRequestEmailChange:
      "Se ti sei accorto di aver inserito un numero sbagliato, {link} per richiederne la modifica.",
  },
};
